import { render, staticRenderFns } from "./CTenant.vue?vue&type=template&id=3325d096"
import script from "./CTenant.vue?vue&type=script&lang=js"
export * from "./CTenant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3325d096')) {
      api.createRecord('3325d096', component.options)
    } else {
      api.reload('3325d096', component.options)
    }
    module.hot.accept("./CTenant.vue?vue&type=template&id=3325d096", function () {
      api.rerender('3325d096', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/components/CTenant.vue"
export default component.exports